import { HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CapacitorHttp, HttpOptions, HttpResponse } from '@capacitor/core';
import { Observable, from } from 'rxjs';

import { environment } from '@ninety/mobile/platform/environments';

@Injectable({ providedIn: 'root' })
export class CapacitorHttpService {
  /** Low-level passthrough to the plugin, adapted to an Observable. */
  request(options: HttpOptions): Observable<HttpResponse> {
    return from(CapacitorHttp.request(options));
  }

  /** Maps an Angular request to Capacitor options and executes it. */
  requestFromNgRequest(req: HttpRequest<unknown>): Observable<HttpResponse> {
    return this.request(this.toCapacitorOptions(req));
  }

  toCapacitorOptions(req: HttpRequest<unknown>): HttpOptions {
    const url = new URL(req.urlWithParams);
    const params = Object.fromEntries(url.searchParams.entries());
    const headers = req.headers.keys().reduce(
      (acc, key) => {
        acc[key] = req.headers.get(key) ?? '';
        return acc;
      },
      {} as { [key: string]: string }
    );
    headers['Accept'] = 'application/json, text/plain, */*';
    headers['ninety-origin'] = environment.nativeHostName;
    headers['Referer'] = environment.nativeHostName;
    headers['Origin'] = environment.nativeHostName;
    if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(req.method)) {
      headers['Content-Type'] = 'application/json';
    }
    const options: HttpOptions = { url: url.origin + url.pathname, method: req.method, headers, params };
    if (req.method.toLowerCase() !== 'get') {
      options.data = JSON.stringify(req.body);
    }
    return options;
  }
}
